import React from 'react';
import appLogo from '../../images/logo.png';
import Loader from 'react-loader-spinner';

const LoadingPage = () => {
    return (

        <div className="position-fixed bg-app w-100 h-100 nav justify-content-center align-items-center" style={style} >
            <div>
                <img className="mb-4" src={appLogo} alt=""  height="100" />
                <Loader className="mt-4 nav justify-content-center"
                    type="ThreeDots"
                    color="#fff"
                    height={80}
                    width={80}
                    timeout={0} />
            </div>
        </div>
    );
}

const style = {
    zIndex: 10000,
}

export default LoadingPage;